import { Helmet } from "react-helmet-async";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const SEO = ({ title, description, image, path = "", type = "website", jsonLd }) => {
  const fullTitle = title ? `${title} | BookMala` : "BookMala - India's Magazine Subscription Store";
  const desc = description || "Subscribe to India's best magazines - Business, Lifestyle, Kids, Devotional, Health and more. Print + digital, easy cancellation, secure payments.";
  const img = image ? (image.startsWith("http") ? image : `${BASE}${image}`) : "";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={`${BASE}${path}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={`${BASE}${path}`} />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
